






































import { tPayTransactionInfo } from '@/store/interfaces/transactions';
import CreditCard from '@/components/Reusable/CreditCard.vue';
import PaymentMethods from '@/components/Reusable/paymentMethods.vue';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'Pay',
  components: { CreditCard, PaymentMethods, },
  props: {
    pay: {
      required: true,
      type: Object as PropType<tPayTransactionInfo>,
    },
  },
  computed: {
    cardAmountCents(): string {
      if (this.pay.card_amount_formatted) return this.pay.card_amount_formatted;
      return '$0.00';
    },
    balanceAmountCents(): string {
      if (this.pay.balance_amount_formatted) {
        return this.pay.balance_amount_formatted;
      }
      return '$0.00';
    },
    total(): string {
      return this.pay.total_formatted;
    },
    isCreditCardOrBot(): boolean {
      return (
        this.pay.distribution === 'credit_card' ||
        this.pay.distribution === 'both'
      );
    },
    isBoth(): boolean {
      return this.pay.distribution === 'both';
    },
  },
});
